import React from 'react';
import PropTypes from 'prop-types';
import {
  formatBoardRelativeTime,
  formatBoardShortAuthor,
  formatBoardUserInitials,
  stripHtmlToText,
} from '../board/boardDisplayUtils';

export function ClubBoardReplyList({
  replies = [],
  emptyMessage = 'No replies yet.',
  renderAfterReply,
  hideBodyForId,
  renderBodyOverride,
}) {
  if (!replies.length) {
    return <p className="club-board-post__no-replies text-muted small mb-0">{emptyMessage}</p>;
  }

  return (
    <div className="club-board-post__reply-list">
      {replies.map((reply) => {
        const hideBody = hideBodyForId != null && String(hideBodyForId) === String(reply.id);
        const bodyOverride = renderBodyOverride?.(reply);
        return (
          <div key={reply.id} className="club-board-post__reply-wrap">
            <div className="club-board-post__reply">
              <span className="club-board-post__reply-avatar" aria-hidden="true">
                {formatBoardUserInitials(reply.author)}
              </span>
              <div className="club-board-post__reply-content">
                <div className="club-board-post__reply-head">
                  <span className="club-board-post__reply-author">
                    {formatBoardShortAuthor(reply.author)}
                  </span>
                  <span className="club-board-post__time">
                    {formatBoardRelativeTime(reply.created_at)}
                  </span>
                </div>
                {!hideBody &&
                  (bodyOverride || (
                    <p className="club-board-post__reply-body">
                      {reply.body_text || stripHtmlToText(reply.body_html)}
                    </p>
                  ))}
              </div>
            </div>
            {renderAfterReply?.(reply)}
          </div>
        );
      })}
    </div>
  );
}

ClubBoardReplyList.propTypes = {
  replies: PropTypes.arrayOf(PropTypes.object),
  emptyMessage: PropTypes.string,
  renderAfterReply: PropTypes.func,
  hideBodyForId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  renderBodyOverride: PropTypes.func,
};
